module.exports = "/fonts/quark-bold.woff?ec5c9865bd48d09b278ccaf7cca11194";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/fonts/Quark/quark-bold.woff
// module id = Lasx
// module chunks = 0